function materials (apiConfig) {
  return {
    getMaterials (successFunc, failFunc) {
      const route = '/v1/materials'
      const rq = apiConfig.context.$http.get(
        route,
        apiConfig.requestObj()
      )
      return apiConfig.buildPromise(rq, successFunc, failFunc)
    },
  }
}
export default materials
